import {
  ES_CHEQUE_GET_BY_ESCONTRACT_ID,
  ES_CHEQUE_GET_BY_ESCONTRACT_ID_SUCCESS,
  ES_CHEQUE_GET_BY_ESCONTRACT_ID_ERROR,
  ES_CHEQUE_GET_BY_ID,
  ES_CHEQUE_GET_BY_ID_SUCCESS,
  ES_CHEQUE_GET_BY_ID_ERROR,
  ES_CHEQUE_ADD_NEW,
  ES_CHEQUE_ADD_NEW_SUCCESS,
  ES_CHEQUE_ADD_NEW_ERROR,
  ES_CHEQUE_EDIT,
  ES_CHEQUE_EDIT_SUCCESS,
  ES_CHEQUE_EDIT_ERROR,
  ES_CHEQUE_DELETE,
  ES_CHEQUE_DELETE_SUCCESS,
  ES_CHEQUE_DELETE_ERROR,
} from '../actions';

const initialState = {
  items: [],
  item: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ES_CHEQUE_DELETE:
    case ES_CHEQUE_EDIT:
    case ES_CHEQUE_ADD_NEW:
    case ES_CHEQUE_GET_BY_ID:
    case ES_CHEQUE_GET_BY_ESCONTRACT_ID:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ES_CHEQUE_GET_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
        loading: false,
      };

    case ES_CHEQUE_GET_BY_ESCONTRACT_ID_SUCCESS:
      return {
        ...state,
        items: payload,
        loading: false,
      };

    case ES_CHEQUE_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
        items: state.items.concat(payload),
      };

    case ES_CHEQUE_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        item: payload,
        error: null,
      };

    case ES_CHEQUE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(c => c.id !== payload),
        error: null,
      };

    case ES_CHEQUE_GET_BY_ESCONTRACT_ID_ERROR:
    case ES_CHEQUE_GET_BY_ID_ERROR:
    case ES_CHEQUE_ADD_NEW_ERROR:
    case ES_CHEQUE_EDIT_ERROR:
    case ES_CHEQUE_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
